<body class="d-body">
  <div class="body create-course">
    <iq-central-front-end-navbar></iq-central-front-end-navbar>
    <div class="container">
      <div class="row">
        <div class="col-lg-2 col-sm-12"></div>
        <div class="col-lg-8 col-sm-12">
          <ul class="nav nav-pills mb-3 justify-content-center mt-5">
            <li class="nav- click">
              <a class="nav-link active">
                <span class="number">1</span> COURSE OVERVIEW</a
              >
            </li>
            <li class="nav-item click">
              <a class="nav-link"> <span class="number">2</span> ADD LESSONS</a>
            </li>
            <li class="nav-item click">
              <a class="nav-link"><span class="number">3</span>CERTIFICATION</a>
            </li>
          </ul>
        </div>
        <div class="col-lg-2 col-sm-12"></div>
      </div>
    </div>

    <section class="h-100">
      <div class="loader" *ngIf="isFetching">
        <div class="overlay"></div>
        <mat-spinner diameter="40"></mat-spinner>
      </div>
      <div class="container" *ngIf="!isFetching">
        <form action="" [formGroup]="createCourseForm">
          <div class="mt-5 mb-3 col-12">
            <p class="font24 text-grey font-bold">Course Title</p>
            <input
              class="largeInput"
              type="text"
              placeholder="Course Title"
              formControlName="title"
              [ngClass]="{
                'is-invalid':
                  createCourseForm.get('title').errors &&
                  createCourseForm.get('title').touched
              }"
            />
            <div class="invalid-feedback mt-0 p-0">
              Please enter course title
            </div>
          </div>

          <div class="row mt-5 mb-3 mx-0">
            <div class="col-lg-4 col-sm-12">
              <p class="font24 text-grey font-bold">Choose Course Category</p>

              <ng-select
                class="font24 text-grey"
                [items]="categories"
                [multiple]="false"
                [closeOnSelect]="true"
                [searchable]="true"
                bindLabel="name"
                bindValue="id"
                formControlName="id"
                placeholder="Select Category"
                (change)="getAllSubCategories($event)"
              >
              </ng-select>
              <div class="invalid-feedback">Please select a category</div>
            </div>

            <div class="col-lg-4 col-sm-12 sm-mt">
              <div class="d-flex justify-content-center align-items-center">
                <p class="font24 text-grey font-bold">Choose Sub Category</p>

                <span *ngIf="isFetchingSubcategories" class="ml-4"
                  ><i class="fa fa-spinner fa-spin"></i
                ></span>
              </div>

              <ng-select
                class="font24 text-grey font-bold"
                [items]="subCategories"
                [multiple]="false"
                [closeOnSelect]="true"
                [searchable]="true"
                bindLabel="name"
                bindValue="id"
                formControlName="category"
                placeholder="Sub Category"
                (change)="getAllTopics($event)"
                [ngClass]="{
                  'is-invalid':
                    createCourseForm.get('category').errors &&
                    createCourseForm.get('category').touched
                }"
              >
              </ng-select>

              <div class="invalid-feedback">Please select a subcategory</div>
            </div>

            <div class="col-lg-4 col-sm-12 sm-mt">
              <p class="font24 text-grey font-bold">Choose Course Topics</p>
              <ng-select
                class="font24 text-grey font-bold"
                [items]="topics"
                [multiple]="true"
                bindLabel="name"
                groupBy="gender"
                [selectableGroup]="true"
                [closeOnSelect]="topics.length === 1 ? true : false"
                bindValue="id"
                formControlName="topics"
                placeholder="Select Topics"
                [ngClass]="{
                  'is-invalid':
                    createCourseForm.get('topics').errors &&
                    createCourseForm.get('topics').touched
                }"
              >
              </ng-select>
              <div class="invalid-feedback">No topics have been selected</div>
            </div>
          </div>
          <div class="mt-4 mb-3 col-12">
            <p class="font24 text-grey font-bold">Course Description</p>
            <div class="bg-white px-1 py-3 border-radius">
              <angular-editor
                [placeholder]="'Enter text here...'"
                formControlName="description"
                [config]="config"
                [ngClass]="{
                  'is-invalid':
                    createCourseForm.get('description').errors &&
                    createCourseForm.get('description').touched
                }"
              ></angular-editor>

              <div class="invalid-feedback mt-0 p-0">
                Describe this course in a few words
              </div>
            </div>
          </div>

          <div class="row mt-5 mb-3 mx-0">
            <div class="col-lg-4 col-sm-12">
              <p class="font24 text-grey font-bold">Choose Course Level</p>
              <mat-form-field class="form">
                <mat-select
                  formControlName="level"
                  [ngClass]="{
                    'is-invalid':
                      createCourseForm.get('level').errors &&
                      createCourseForm.get('level').touched
                  }"
                >
                  <mat-option value="BASIC">BASIC</mat-option>
                  <mat-option value="INTERMEDIATE">INTERMEDIATE</mat-option>
                  <mat-option value="EXPERT">EXPERT</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col-lg-4 col-12" *ngIf="this.courseData">
              <p class="font24 text-grey pb-3">Course Code</p>
              <input
                type="text"
                class="largeInput"
                formControlName="courseCode"
              />
            </div>

            <div class="col-lg-4 col-12">
              <p class="font24 text-grey pb-3 font-bold">Thumbnail</p>
              <app-file-upload
                [file]="courseData?.imageUrl"
                formControlName="picture"
                [placeholder]="'Upload Image'"
                [elementId]="'courseImage'"
                [ngClass]="{
                  'is-invalid': createCourseForm
                    .get('picture')
                    .hasError('requiredFileType')
                }"
              ></app-file-upload>
              <div class="invalid-feedback mt-0 p-0">png and jpg only</div>
              <div
                class="mt-0 p-0 text-danger"
                *ngIf="createCourseForm.get('picture').hasError('required')"
              >
                Required
              </div>
            </div>
          </div>

          <div class="row mt-5 mb-3 mx-0">
            <div class="col-lg-4 col-sm-12">
              <p class="font24 text-grey font-bold">Has Certificate?</p>
              <mat-form-field>
                <mat-select
                  formControlName="hasCertificate"
                  [ngClass]="{
                    'is-invalid':
                      createCourseForm.get('hasCertificate').errors &&
                      createCourseForm.get('hasCertificate').touched
                  }"
                >
                  <mat-option [value]="true">YES</mat-option>
                  <mat-option [value]="false">NO</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div
              class="col-sm-12 col-lg-4 sm-mt"
              *ngIf="createCourseForm.get('hasCertificate').value === true"
            >
              <p class="font24 text-grey font-bold">Certificate Type</p>
              <mat-form-field>
                <mat-select
                  formControlName="certificateType"
                  [ngClass]="{
                    'is-invalid':
                      createCourseForm.get('certificateType').errors &&
                      createCourseForm.get('certificateType').touched
                  }"
                >
                  <mat-option value="GENERIC">GENERIC</mat-option>
                  <mat-option value="CUSTOM">CUSTOM</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div
              class="col-lg-4 col-12"
              *ngIf="createCourseForm.get('hasCertificate').value === true"
            >
              <p class="font24 text-grey pb-3 font-bold">Certificate Upload</p>
              <app-file-upload
                [file]="courseData?.certificateFileUrl"
                formControlName="certificate"
                [ngClass]="{
                  'is-invalid': createCourseForm
                    .get('certificate')
                    .hasError('requiredFileType')
                }"
                [placeholder]="'Upload PDF'"
                [elementId]="'imageFile'"
              ></app-file-upload>
              <div class="invalid-feedback mt-0 p-0">pdf only</div>
            </div>
          </div>

          <div class="text-right my-5 d-flex justify-content-end">
            <button
              class="btn btn-secondary next ml-4"
              (click)="finish()"
              [disabled]="createCourseForm.invalid"
            >
              Finish
            </button>
            <button
              class="btn btn-secondary next ml-4"
              (click)="addLesson('add-lesson')"
            >
              Add lesson
              <span *ngIf="isLoading" class="ml-4"
                ><i class="fa fa-spinner fa-spin"></i
              ></span>
            </button>
          </div>
        </form>
      </div>
    </section>
  </div>
  <div class="mt-auto hidden">
    <div class="footer-wrapper container">
      <hr />
      <iq-central-front-end-footer></iq-central-front-end-footer>
    </div>
  </div>
</body>
